import React from 'react'
import { useDispatch } from 'react-redux'
import Paxes from 'src/comps/Molecules/Paxes'
import { updateSearchAction } from 'src/effects/Search/actions'
import { Room, SearchMode } from 'src/types/search'
import noop from 'lodash/noop'
import { getRoomsFromLocalParams } from 'src/context/search/utils'

interface IPaxes {
  adults: number[]
  children: number[][]
}

interface IPaxesConnectedProps {
  readonly initialPaxes: IPaxes
  readonly mode?: SearchMode
  readonly onSave?: () => void
}

export const PaxesConnected = (props: IPaxesConnectedProps) => {
  const { initialPaxes, mode = SearchMode.Borderless, onSave = noop } = props
  const dispatch = useDispatch()

  function updatePaxes(eventData: Room[]) {
    const changedAdults = eventData.map(room => room.adults)
    const changedChildren = eventData.map(room => room.children)

    const changedPaxes = { adults: changedAdults, children: changedChildren }

    if (JSON.stringify(initialPaxes) !== JSON.stringify(changedPaxes)) {
      dispatch(updateSearchAction(changedPaxes))
    }
    onSave()
  }

  return (
    <Paxes
      mode={mode}
      initialValue={getRoomsFromLocalParams(initialPaxes.adults, initialPaxes.children)}
      onChange={updatePaxes}
    />
  )
}
